/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JsonPatchDocument } from '../models/json-patch-document';
import { Rate } from '../models/rate';
import { RateChange } from '../models/rate-change';

@Injectable({
  providedIn: 'root',
})
export class RatesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getRates
   */
  static readonly GetRatesPath = '/api/v1/Rates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRates$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRates$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Rate>>> {

    const rb = new RequestBuilder(this.rootUrl, RatesService.GetRatesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Rate>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRates$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRates$Plain(params?: {
  },
  context?: HttpContext

): Observable<Array<Rate>> {

    return this.getRates$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Rate>>) => r.body as Array<Rate>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRates$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Rate>>> {

    const rb = new RequestBuilder(this.rootUrl, RatesService.GetRatesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Rate>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRates(params?: {
  },
  context?: HttpContext

): Observable<Array<Rate>> {

    return this.getRates$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Rate>>) => r.body as Array<Rate>)
    );
  }

  /**
   * Path part for operation getRateById
   */
  static readonly GetRateByIdPath = '/api/v1/Rates/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRateById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRateById$Plain$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Rate>> {

    const rb = new RequestBuilder(this.rootUrl, RatesService.GetRateByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Rate>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRateById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRateById$Plain(params: {
    id: string;
  },
  context?: HttpContext

): Observable<Rate> {

    return this.getRateById$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Rate>) => r.body as Rate)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRateById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRateById$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Rate>> {

    const rb = new RequestBuilder(this.rootUrl, RatesService.GetRateByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Rate>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRateById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRateById(params: {
    id: string;
  },
  context?: HttpContext

): Observable<Rate> {

    return this.getRateById$Response(params,context).pipe(
      map((r: StrictHttpResponse<Rate>) => r.body as Rate)
    );
  }

  /**
   * Path part for operation deleteRateById
   */
  static readonly DeleteRateByIdPath = '/api/v1/Rates/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRateById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRateById$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, RatesService.DeleteRateByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRateById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRateById(params: {
    id: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteRateById$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation patchRate
   */
  static readonly PatchRatePath = '/api/v1/Rates/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchRate$Plain()` instead.
   *
   * This method sends `application/json-patch+json` and handles request body of type `application/json-patch+json`.
   */
  patchRate$Plain$Response(params: {
    id: string;
    body?: JsonPatchDocument
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Rate>> {

    const rb = new RequestBuilder(this.rootUrl, RatesService.PatchRatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json-patch+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Rate>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchRate$Plain$Response()` instead.
   *
   * This method sends `application/json-patch+json` and handles request body of type `application/json-patch+json`.
   */
  patchRate$Plain(params: {
    id: string;
    body?: JsonPatchDocument
  },
  context?: HttpContext

): Observable<Rate> {

    return this.patchRate$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Rate>) => r.body as Rate)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchRate()` instead.
   *
   * This method sends `application/json-patch+json` and handles request body of type `application/json-patch+json`.
   */
  patchRate$Response(params: {
    id: string;
    body?: JsonPatchDocument
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Rate>> {

    const rb = new RequestBuilder(this.rootUrl, RatesService.PatchRatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json-patch+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Rate>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchRate$Response()` instead.
   *
   * This method sends `application/json-patch+json` and handles request body of type `application/json-patch+json`.
   */
  patchRate(params: {
    id: string;
    body?: JsonPatchDocument
  },
  context?: HttpContext

): Observable<Rate> {

    return this.patchRate$Response(params,context).pipe(
      map((r: StrictHttpResponse<Rate>) => r.body as Rate)
    );
  }


  /**
   * Path part for operation getSharedRates
   */
  static readonly GetSharedRatesPath = '/api/v1/Rates/Shared';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSharedRates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSharedRates$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Rate>>> {

    const rb = new RequestBuilder(this.rootUrl, RatesService.GetSharedRatesPath, 'get');
    if (params) {

    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Rate>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSharedRates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSharedRates(params?: {
  },
  context?: HttpContext

): Observable<Array<Rate>> {

    return this.getSharedRates$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Rate>>) => r.body as Array<Rate>)
    );
  }

  /**
   * Path part for operation addRate
   */
  static readonly AddRatePath = '/api/v1/Rates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addRate()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addRate$Response(params?: {
    body?: RateChange
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Rate>> {

    const rb = new RequestBuilder(this.rootUrl, RatesService.AddRatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Rate>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addRate$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addRate(params?: {
    body?: RateChange
  },
  context?: HttpContext

): Observable<Rate> {

    return this.addRate$Response(params,context).pipe(
      map((r: StrictHttpResponse<Rate>) => r.body as Rate)
    );
  }

  /**
   * Path part for operation updateRate
   */
  static readonly UpdateRatePath = '/api/v1/Rates/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRate()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateRate$Response(params: {
    id: string;
    body?: RateChange
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Rate>> {

    const rb = new RequestBuilder(this.rootUrl, RatesService.UpdateRatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Rate>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRate$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateRate(params: {
    id: string;
    body?: RateChange
  },
  context?: HttpContext

): Observable<Rate> {

    return this.updateRate$Response(params,context).pipe(
      map((r: StrictHttpResponse<Rate>) => r.body as Rate)
    );
  }

}
